import { OnlineResolutionsPostRequest } from '@/dtos/resolutions/online-resolution/post'

export class OnlineResolutionsDraftPostRequest extends OnlineResolutionsPostRequest {}
